import DefaultColumnTypes from '../../../components/grids/columns/Column.constants';
import React, { useContext } from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BaseGrid from '../../../components/grids/BaseGrid';
import { AgGridColumn } from 'ag-grid-react';
import { ExportEntryRow } from './hooks/useFixedAssetDisposalEntriesGrid';
import SettingsContext from '../../../contexts/settings.context';
import { useGetTermSetQuery } from '../../../services/i18n/i18n.service';
import { ACCOUNTING_DEFS } from '../../../constants/i18n/translations/termSetDefinitions/accounting';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { DisposalEntriesGridDefs } from '../../../constants/i18n/translations/termDefinitions/accounting';
import TranslatableText from '../../../components/i18n/TranslatableText';

export interface DisposalEntriesExportProps {
    open: boolean;
    selected: ExportEntryRow[];
    onClose: () => void;
}

const FixedAssetDisposalEntriesExportModal = (
    props: DisposalEntriesExportProps
) => {
    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: ACCOUNTING_DEFS.DISPOSAL_ENTRIES_GRID,
              }
            : skipToken
    );
    return (
        <Dialog open={props.open} fullWidth maxWidth={'lg'}>
            <DialogTitle>
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                        <TranslatableText
                            termSet={termSet}
                            termKey={
                                DisposalEntriesGridDefs.Download_Entries_Title
                            }
                        />
                    </Box>
                    <Box>
                        <IconButton onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <BaseGrid
                    paginationPageSize={30}
                    rowData={props.selected}
                    displayGrid={true}
                    displayToolbar={true}
                    defaultColDef={{ flex: 1 }}
                    displayExportDataButton={true}>
                    <AgGridColumn
                        field="entryDate"
                        headerComponentFramework={(props: any) => {
                            return (
                                <TranslatableText
                                    termSet={termSet}
                                    termKey={DisposalEntriesGridDefs.Date}
                                />
                            );
                        }}
                        sort="asc"
                        {...DefaultColumnTypes.DateOnly}
                    />
                    <AgGridColumn
                        field="accountNo"
                        headerComponentFramework={(props: any) => {
                            return (
                                <TranslatableText
                                    termSet={termSet}
                                    termKey={
                                        DisposalEntriesGridDefs.Account_Number
                                    }
                                />
                            );
                        }}
                        sort="asc"
                    />
                    <AgGridColumn
                        field="accountName"
                        headerComponentFramework={(props: any) => {
                            return (
                                <TranslatableText
                                    termSet={termSet}
                                    termKey={
                                        DisposalEntriesGridDefs.Entry_Description
                                    }
                                />
                            );
                        }}
                    />
                    <AgGridColumn
                        field="debit"
                        headerComponentFramework={(props: any) => {
                            return (
                                <TranslatableText
                                    termSet={termSet}
                                    termKey={DisposalEntriesGridDefs.Debit}
                                />
                            );
                        }}
                        {...DefaultColumnTypes.Currency}
                    />
                    <AgGridColumn
                        field="credit"
                        headerComponentFramework={(props: any) => {
                            return (
                                <TranslatableText
                                    termSet={termSet}
                                    termKey={DisposalEntriesGridDefs.Credit}
                                />
                            );
                        }}
                        {...DefaultColumnTypes.Currency}
                    />
                </BaseGrid>
            </DialogContent>
        </Dialog>
    );
};

export default FixedAssetDisposalEntriesExportModal;
